import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  TablePagination,
  IconButton,
  Autocomplete
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createVulnerabilidades, deleteVulnerabilidades, getVulnerabilidades, getVulnerabilidadPorEmpresa, updateVulnerabilidades } from '../../services/vulnerabilidades/vulnerabilidadesData';
import { getTiposVulnerabilidad } from '../../services/vulnerabilidades/tiposVulnerabilidad/tiposVulnerabilidadData';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const TablaVulnerabilidades = () => {
  const [datos, setDatos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [tiposIds, setTiposIds] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [modificarIndex, setModificarIndex] = useState(-1);
  const { user } = useAuth();
  const emp_codigo = user?.emp_codigo;

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [formulario, setFormulario] = useState({
    Tipo: '',
    FechaInicio: '',
    Identificacion: '',
    Nombre: '',
    Descripción: '',
    Observacion: '',
    FechaInactividad: null,
  });

  const datosFiltrados = datos.filter((dato) => {
    const texto = busqueda.toLowerCase();
    return dato.vul_nombre && dato.vul_nombre.toLowerCase().includes(texto);
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (emp_codigo) {
          const vulnerabilidadesData = await getVulnerabilidadPorEmpresa(emp_codigo);
          setDatos(Array.isArray(vulnerabilidadesData) ? vulnerabilidadesData : []);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setDatos([]);
      }
    };

    fetchData();
  }, [emp_codigo]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tiposVulnerabilidadData = await getTiposVulnerabilidad();
        setTipos(Array.isArray(tiposVulnerabilidadData) ? tiposVulnerabilidadData : []);
      } catch (error) {
        console.error('Error fetching data:', error);
        setTipos([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(tipos) && tipos.length > 0) {
      const tiposIds1 = tipos.map((item) => item.tvu_codigo);
      setTiposIds(tiposIds1);
    } else {
      setTiposIds([]);
    }
  }, [tipos]);

  const handleBusquedaChange = (event) => {
    setBusqueda(event.target.value);
    setPage(0);
  };

  const handleDateChange = (newValue) => {
    const formattedDate = dayjs(newValue).format('YYYY-MM-DD');
    setFormulario({
      ...formulario,
      FechaInicio: formattedDate,
    });
  };
  const handleFechaInactividadChange = (newValue) => {
    const formattedDate = dayjs(newValue).format('YYYY-MM-DD');
    setFormulario({
      ...formulario,
      FechaInactividad: formattedDate,
    });
  };
  const handleInsert = () => {
    setModificarIndex(-1);
    setFormulario({
      Tipo: '',
      FechaInicio: dayjs().format('YYYY-MM-DD'),
      Identificacion: generarIdentificacion(),
      Nombre: '',
      Descripción: '',
      Observacion: '',
      FechaInactividad: null,
    });
    setModalOpen(true);
  };

  const handleFormChange = (event) => {
    setFormulario({
      ...formulario,
      [event.target.name]: event.target.value,
    });
  };

  const handleGuardar = async () => {
    const camposFaltantes = [];
    if (!formulario.Tipo) camposFaltantes.push("Tipo");
    if (!formulario.FechaInicio) camposFaltantes.push("Fecha de Inicio");
    if (!formulario.Identificacion) camposFaltantes.push("Identificación");
    if (!formulario.Nombre) camposFaltantes.push("Nombre");
    if (!formulario.Descripción) camposFaltantes.push("Descripción");
    if (!formulario.Observacion) camposFaltantes.push("Observación");

    if (camposFaltantes.length > 0) {
      toast.warning(`Faltan campos obligatorios: ${camposFaltantes.join(", ")}`);
      return;
    }
    const dataToSend = {
      emp_codigo: emp_codigo,
      tvu_codigo: formulario.Tipo,
      vul_fecha_inicio: formulario.FechaInicio,
      vul_identificacion: formulario.Identificacion,
      vul_nombre: formulario.Nombre,
      vul_descripcion: formulario.Descripción,
      vul_observacion: formulario.Observacion,
      vul_fecha_inactividad: formulario.FechaInicio,
    };
    try {
      if (modificarIndex !== -1) {
        await updateVulnerabilidades(modificarIndex, dataToSend);
        const vulnerabilidadesData = await getVulnerabilidadPorEmpresa(emp_codigo);
        setDatos(Array.isArray(vulnerabilidadesData) ? vulnerabilidadesData : []);
        toast.success("Vulnerabilidad modificada correctamente");
      } else {
        await createVulnerabilidades(dataToSend);
        const vulnerabilidadesData = await getVulnerabilidadPorEmpresa(emp_codigo);
        setDatos(Array.isArray(vulnerabilidadesData) ? vulnerabilidadesData : []);
        toast.success("Vulnerabilidad creada correctamente");
      }
      setModalOpen(false);
      setFormulario({
        Tipo: '',
        FechaInicio: '',
        Identificacion: '',
        Nombre: '',
        Descripción: '',
        Observacion: '',
        FechaInactividad: null,
      });
    } catch (error) {
      console.error("Error saving vulnerabilidad:", error);
      toast.error("Error al guardar la vulnerabilidad");
    }
  };

  const handleCancelar = () => {
    setModalOpen(false);
    setFormulario({
      Tipo: '',
      FechaInicio: '',
      Identificacion: '',
      Nombre: '',
      Descripción: '',
      Observacion: '',
      FechaInactividad: null,
    });
  };

  const handleModificar = (index) => {
    const selectedTipo = tipos.find((tipo) => tipo.tvu_codigo === datos[index].tvu_codigo);
    setModificarIndex(datos[index].vul_codigo);
    setFormulario({
      Tipo: selectedTipo ? selectedTipo.tvu_codigo : '',
      FechaInicio: datos[index].vul_fecha_inicio ? datos[index].vul_fecha_inicio.split('T')[0] : datos[index].vul_fecha_inicio,
      Identificacion: datos[index].vul_identificacion,
      Nombre: datos[index].vul_nombre,
      Descripción: datos[index].vul_descripcion,
      Observacion: datos[index].vul_observacion,
      FechaInactividad: datos[index].vul_fecha_inactividad ? datos[index].vul_fecha_inactividad.split('T')[0] : datos[index].vul_fecha_inactividad,
    });
    setModalOpen(true);
  };

  const handleEliminar = (index) => {
    setDeleteIndex(index);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    const codigoToDelete = datos[deleteIndex].vul_codigo;
    try {
      await deleteVulnerabilidades(codigoToDelete);
      toast.success("Vulnerabilidad eliminada correctamente");
      const vulnerabilidadesData = await getVulnerabilidadPorEmpresa(emp_codigo);
      setDatos(Array.isArray(vulnerabilidadesData) ? vulnerabilidadesData : []);
      setConfirmOpen(false);
      setDeleteIndex(null);
    } catch (error) {
      setConfirmOpen(false);
      const errorMsg =
        error?.message ||
        error?.response?.data?.message ||
        "No se puede eliminar la vulnerabilidad porque está siendo utilizada en el sistema.";
      if (
        error?.status === 400 ||
        errorMsg.toLowerCase().includes("no se puede eliminar") ||
        errorMsg.toLowerCase().includes("asociada") ||
        errorMsg.toLowerCase().includes("utilizada") ||
        error?.response?.data?.errno === 1451 ||
        (error?.response?.data?.code && error.response.data.code.includes("ER_ROW_IS_REFERENCED"))
      ) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      } else {
        toast.error(errorMsg);
      }
      setDeleteIndex(null);
    }
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
    setDeleteIndex(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function generarIdentificacion() {
    const letras = Array(3)
      .fill(0)
      .map(() => String.fromCharCode(65 + Math.floor(Math.random() * 26)))
      .join('');
    const numeros = String(Math.floor(Math.random() * 1000)).padStart(3, '0');
    return `${letras}-${numeros}`;
  }

  // Obtener descripción del tipo por código
  const getTipoDescripcion = (codigo) => {
    const tipo = tipos.find((t) => t.tvu_codigo === codigo);
    return tipo ? tipo.tvu_descripcion : codigo;
  };

  return (
    <Box>
      {/* Toolbar */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2,
          borderBottom: '1px solid #e0e0e0'
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Buscar vulnerabilidad..."
          value={busqueda}
          onChange={handleBusquedaChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: { xs: '100%', sm: 300 } }}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleInsert}
          sx={{
            backgroundColor: '#001F3F',
            color: '#fff',
            '&:hover': { backgroundColor: '#003366' },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Nueva Vulnerabilidad
        </Button>
      </Box>

      <TableContainer>
        <Table sx={{ minWidth: 750 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Tipo</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Fecha Inicio</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Identificación</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Nombre</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Descripción</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Observación</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Fecha Inactividad</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }} align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {datosFiltrados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                  <Typography variant="body1" sx={{ color: '#666' }}>
                    {datos.length === 0 ? "No hay vulnerabilidades registradas." : "No se encontraron resultados."}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              datosFiltrados
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((dato, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{getTipoDescripcion(dato.tvu_codigo)}</TableCell>
                    <TableCell>{dato.vul_fecha_inicio ? dato.vul_fecha_inicio.split('T')[0] : ''}</TableCell>
                    <TableCell>{dato.vul_identificacion}</TableCell>
                    <TableCell>{dato.vul_nombre}</TableCell>
                    <TableCell>{dato.vul_descripcion}</TableCell>
                    <TableCell>{dato.vul_observacion}</TableCell>
                    <TableCell>{dato.vul_fecha_inactividad ? dato.vul_fecha_inactividad.split('T')[0] : ''}</TableCell>
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <IconButton onClick={() => handleModificar(index + (page * rowsPerPage))} size="small" sx={{ color: "#666" }}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton onClick={() => handleEliminar(index + (page * rowsPerPage))} size="small" sx={{ color: "#d32f2f" }}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datosFiltrados.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
      />

      {/* Modal Formulario */}
      <Dialog
        open={modalOpen}
        onClose={handleCancelar}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pb: 2, fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          {modificarIndex !== -1 ? 'Modificar Vulnerabilidad' : 'Nueva Vulnerabilidad'}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                name="Tipo"
                value={tipos
                  .map((tipo) => ({ label: tipo.tvu_descripcion, value: tipo.tvu_codigo }))
                  .find(opt => opt.value === formulario.Tipo) || null}
                options={tipos.map((tipo) => ({
                  label: tipo.tvu_descripcion,
                  value: tipo.tvu_codigo
                }))}
                sx={{ width: "100%" }}
                getOptionLabel={(option) => option?.label || ""}
                onChange={(event, newValue) => {
                  setFormulario({
                    ...formulario,
                    Tipo: newValue ? newValue.value : '',
                  });
                }}
                renderInput={(params) => <TextField {...params} label="Tipos de Vulnerabilidad" variant="outlined" />}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha de Inicio"
                  name="FechaInicio"
                  value={dayjs(formulario.FechaInicio)}
                  onChange={handleDateChange}
                  minDate={dayjs()}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Box>

            <TextField
              label="Identificacion"
              name="Identificacion"
              fullWidth
              value={formulario.Identificacion}
              onChange={handleFormChange}
              variant="outlined"
            />
            <TextField
              label="Nombre"
              name="Nombre"
              fullWidth
              value={formulario.Nombre}
              onChange={handleFormChange}
              variant="outlined"
            />
            <TextField
              label="Descripción"
              name="Descripción"
              fullWidth
              value={formulario.Descripción}
              onChange={handleFormChange}
              variant="outlined"
              multiline
              rows={2}
            />
            <TextField
              label="Observación"
              name="Observacion"
              fullWidth
              value={formulario.Observacion}
              onChange={handleFormChange}
              variant="outlined"
              multiline
              rows={2}
            />
            {modificarIndex !== -1 && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha de Inactividad"
                  name="FechaInactividad"
                  value={dayjs(formulario.FechaInactividad)}
                  onChange={handleFechaInactividadChange}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelar} sx={{ color: '#666' }}>Cancelar</Button>
          <Button
            onClick={handleGuardar}
            variant="contained"
            sx={{
              backgroundColor: '#001F3F',
              color: '#fff',
              '&:hover': { backgroundColor: '#003366' }
            }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal Confirmación Eliminación */}
      <Dialog
        open={confirmOpen}
        onClose={handleCancelDelete}
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          Confirmar Eliminación
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#666' }}>
            ¿Está seguro que desea eliminar esta vulnerabilidad?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelDelete} sx={{ color: '#666' }}>Cancelar</Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            sx={{
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' }
            }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de error */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          No se puede eliminar
        </DialogTitle>
        <DialogContent>
          <Box sx={{ py: 2 }}>
            <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
              {errorMessage || 'Esta vulnerabilidad está siendo utilizada y no puede eliminarse.'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#999' }}>
              Antes de eliminarla, actualiza o elimina las relaciones donde se usa.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setErrorModalOpen(false)}
            variant="contained"
            sx={{ backgroundColor: '#001F3F', color: '#fff', '&:hover': { backgroundColor: '#003366' } }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </Box>

  );
};

export default TablaVulnerabilidades;
